<template>
  <div class="modal-overlay">
    <transition name="modal-expand">
      <div v-if="isVisible" class="products-modal" @click.stop>
        <div class="modal-content" @click.stop> <!-- Stop the click event from propagating to the overlay -->
          <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
          <h2>{{ isEdit ? 'Edit User' : 'Add New User' }}</h2>

          <div class="add">
            <form @submit.prevent="submit">
              <div class="form-group">
                <label for="name">First Name: *</label>
                <input type="text" class="form-control rounded" id="first_name" name="first_name" placeholder="Enter First Name"
                  v-model="form.first_name" />
              </div>
              <div class="form-group">
                <label for="name">Last Name: *</label>
                <input type="text" class="form-control rounded" id="last_name" name="last_name" placeholder="Enter Last Name"
                  v-model="form.last_name" />
              </div>
              <div class="form-group">
                <label for="email">Email: *</label>
                <input type="text" class="form-control rounded" id="email" name="email"
                  placeholder="Enter Email Address" v-model="form.email" />
              </div>
              <!-- <div class="form-group" v-if="!isEdit && isTrainee === false">
                <label for="role">Role: *</label>
                <select class="form-control rounded" id="role" name="role" v-model="form.role">
                  <option value=""></option>
                  <option value="examiner">Examiner</option>
                  <option value="instructor">Instructor</option>
                  <option value="trainee">Trainee</option>
                </select>
              </div> -->
              <div class="form-group" v-if="!isTrainee">
                <label>Roles: *</label>

                <div class="roles-grid">
                  <label class="role-item">
                    <input type="checkbox" value="admin" v-model="form.roles" :disabled="maxRolesReached && !form.roles.includes('admin')" style="width: 16px; height: 16px;" />
                    <span>Admin</span>
                  </label>

                  <label class="role-item">
                    <input type="checkbox" value="examiner" v-model="form.roles" :disabled="maxRolesReached && !form.roles.includes('examiner')" style="width: 16px; height: 16px;" />
                    <span>Examiner</span>
                  </label>

                  <label class="role-item">
                    <input type="checkbox" value="instructor" v-model="form.roles" :disabled="maxRolesReached && !form.roles.includes('instructor')" style="width: 16px; height: 16px;" />
                    <span>Instructor</span>
                  </label>

                  <!-- <label class="role-item">
                    <input type="checkbox" value="trainee" v-model="form.roles" style="width: 16px; height: 16px;" />
                    <span>Trainee</span>
                  </label> -->
                </div>
              </div>
              <div class="form-group">
                <label for="license_no">License No:</label>
                <input type="text" class="form-control rounded" id="license_no" name="license_no"
                  title="License No may only contain letters and numbers"
                  placeholder="License No" v-model="form.license_no" />
              </div>
              <div class="form-group" v-if="!isTrainee">
                <label for="category">Category:</label>
                <input type="text" class="form-control rounded" id="category" name="category"
                  placeholder="Enter the Category" v-model="form.category" />
              </div>
              <div class="form-group" v-if="!isTrainee">
                <label for="department">Department:</label>
                <input type="text" class="form-control rounded" id="department" name="department"
                  placeholder="Enter the Department" v-model="form.department" />
              </div>
              <div class="form-group">
                <label for="date_of_birth">Date of Birth:</label>
                <input type="date" class="form-control rounded" id="date_of_birth" name="date_of_birth"
                  placeholder="DD/MM/YYYY" v-model="form.date_of_birth" />
              </div>
              <div class="form-group">
                <label for="place_of_birth">Place of Birth:</label>
                <input type="text" class="form-control rounded" id="place_of_birth" name="place_of_birth"
                  placeholder="Enter the Place of Birth" v-model="form.place_of_birth" />
              </div>
              <div class="form-group">
                <label for="password">Password: *</label>
                <input :type="showPassword ? 'text' : 'password'" class="form-control rounded" id="password"
                  name="password" placeholder="Create Password" v-model="form.password" />
                <font-awesome-icon class="eye-icon" :icon="['far', showPassword ? 'eye' : 'eye-slash']"
                  @click="toggleShowPassword" />
              </div>
              <div v-if="passwordRules && !passwordValid" class="password-rules" style="margin-top: -20px; padding-right: 70px;">
                <small>{{ passwordRules.description }}</small>
              </div>
              <div class="form-group">
                <label for="reenteredPassword">Re-enter Password: *</label>
                <input :type="showPassword ? 'text' : 'password'" class="form-control rounded" id="reenteredPassword"
                  name="reenteredPassword" placeholder="Re-enter Password" v-model="form.password_confirmation" />
              </div>
              <div v-if="isEdit">
                <p>
                  <b>Note: </b>Leave the password field empty if you do not wish to update it
                </p>
              </div>
              <div v-if="showAlert" class="alert alert-danger error-message" role="alert">
                <div v-if="errorMessage">{{ errorMessage }}</div>
              </div>
              <div>
                <button class="saveButton" type="submit" style="margin-top: 10px;">{{ isEdit ? 'Update User' : 'Save'
                }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    users: Array,
    user: { type: Object, default: null }, // null = Add mode
    mode: { type: String, default: "add" },
    isTrainee: { type: Boolean, default: false }
  },
  data() {
    return {
      form: {
        first_name: '',
        last_name: '',
        roles: [],
        password: '',
        password_confirmation: '', // required by Laravel confirmed
        email: '',
        department: '',
        license_no: '',
        category: '',
        date_of_birth: '',
        place_of_birth: '',
      },
      showAlert: false,
      errorMessage: "",
      showPassword: false,
      isVisible: false,
      passwordRules: null,
    };
  },
  computed: {
    isEdit() {
      return this.mode === "edit";
    },
    hasTraineeRole() { 
      return (this.form.roles || []).includes('trainee'); 
    },
    passwordChecklist() {
      const pw = this.form.password || '';
      const min = this.passwordRules?.min ?? 8;

      return {
        min: pw.length >= min,
        letter: /[A-Za-z]/.test(pw),
        number: /\d/.test(pw),
      };
    },
    maxRolesReached() {
      return this.form.roles.length >= 2;
    },
    passwordValid() {
      return (
        this.passwordChecklist.min &&
        this.passwordChecklist.letter &&
        this.passwordChecklist.number
      );
    },
  },
  methods: {
    formatRole(role) {
      // Format role names to be more readable (e.g., capitalize)
      return role.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
    },
    toggleShowPassword() {
      this.showPassword = !this.showPassword;
    },
    formatDate(date) {
      if (!date) return '';

      // Already correct format (YYYY-MM-DD)
      if (date.includes('-')) return date;

      // Convert from DD/MM/YYYY → YYYY-MM-DD
      const [day, month, year] = date.split('/');
      return `${year}-${month}-${day}`;
    },
    close() {
      this.$emit('close');
    },
    async submit() {
      if (this.form.password || this.form.password_confirmation) {
        if (this.form.password !== this.form.password_confirmation) {
          this.errorMessage = 'Passwords do not match';
          this.showAlert = true;
          return;
        }
      }
      if (!this.form.roles || this.form.roles.length === 0) {
        this.errorMessage = 'Please select at least one role.';
        this.showAlert = true;
        return;
      }
      const license_no = (this.form.license_no || '').trim().toLowerCase();
      const email = (this.form.email || '').trim().toLowerCase();

      // Check duplicate license_no is not empty
      const isDuplicate = license_no && this.users.some(s =>
        ((s.license_no || '').trim().toLowerCase() === license_no) &&
        (!this.isEdit || s.user_id !== this.user?.user_id)
      );

      // Check duplicate if email is not empty
      const isEmailDuplicate = email && this.users.some(s =>
        ((s.email || '').trim().toLowerCase() === email) &&
        (!this.isEdit || s.user_id !== this.user?.user_id)
      );

      if (isDuplicate) {
        window.alert("User external id already exists");
        return;
      }

      if (isEmailDuplicate) {
        window.alert("User email already exists");
        return;
      }

      const formattedDOB = this.formatDate(this.form.date_of_birth);
      const payload = {
        ...this.form,
        date_of_birth: formattedDOB,
      };
      if (this.isEdit && !this.form.password) {
        delete payload.password;
        delete payload.password_confirmation;
      } else if (this.form.password) {
        // Only send password if a new one is provided
        payload.password = this.form.password;
      }

      try {
        const token = localStorage.getItem("token");
        const headers = { Authorization: `Bearer ${token}` };

        let response;

        if (this.isEdit) {
          // PUT update
          response = await axios.put(`/api/users/${this.user.user_id}`, payload, { headers });
        } else {
          // POST add
          response = await axios.post(`/api/users`, payload, { headers });
        }

        if (response.status === 200 || response.status === 201) {
          window.alert(`User ${this.isEdit ? "updated" : "added"} successfully`);
          this.$emit("saved");     // notify parent to refresh
          this.close();
        }
      } catch (error) {
        if (error.isOffline === true) {
          this.$emit('close');
          return;
        }
        console.error('Error updating User:', error.response);
        if (error.response && error.response.data && error.response.data.errors) {
          // Handle validation errors
          const validationErrors = error.response.data.errors;

          // Build an error message from the validation errors
          let errorMessage = 'Validation errors:';
          for (const field in validationErrors) {
            errorMessage += `\n${field}: ${validationErrors[field][0]}`;
          }

          this.errorMessage = errorMessage;
        } else {
          // Handle other errors
          this.errorMessage = 'An error occurred while updating the User.\n' + error.response.data.message;
        }
        this.showAlert = true;
      }
    },
    async fetchPasswordRules() {
      try {
        const res = await axios.get('/api/auth/password-rules');
        this.passwordRules = res.data;
      } catch (e) {
        console.error('Failed to fetch password rules', e);
        this.passwordRules = { description: 'Minimum 8 characters, at least 1 letter and 1 number.', min: 8, requires: { letters: true, numbers: true } };
      }
    },
  },
  async mounted() {
    // Pre-fill fields for editing
    if (this.isEdit && this.user) {
      this.form = {
        ...this.form,
        ...this.user,
        date_of_birth: this.formatDate(this.user.date_of_birth),
        roles: this.user.roles || [],
      };
    }
    if (this.isTrainee) {
      this.form.roles = ['trainee'];
    }
    this.isVisible = true;
    await this.fetchPasswordRules();
  },
};

</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: top;
  z-index: 1000;
}

.products-modal {
  background-color: #ffffff;
  overflow-y: auto;
  /* Enables vertical scrolling if needed */
  margin-top: 10px;
  max-width: 90vw;
  max-height: 97vh;
  min-width: min(800px, 75%);
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  position: fixed;
  display: flex;
  flex-direction: column;
  overflow-wrap: break-word;
  padding: 20px;
  z-index: 1002;
}

.modal-content {
  border: white;
  padding: 15px;
  border: 1px solid #dddddd;
  border-radius: 3px;
}

.saveButton {
  background-color: #0055b1;
  color: #ffffff;
  font-size: 14px;
  padding: 10px;
  border: 1px solid #0a407a;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: auto;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  width: 180px;
  margin-left: 30px;
}

.saveButton:hover {
  background-color: rgb(1, 40, 82);
}

h2 {
  font-size: 30px;
  margin-bottom: 20px;
  margin-left: 25px;
}

.alert-danger {
  color: #ff0019;
  background-color: #f8d7da;
  border: 1px solid #e6b0b6;
}

.alert {
  position: relative;
  padding: .75rem 1.25rem;
  margin-bottom: 0rem;
  border: 1px solid transparent;
  border-radius: .25rem;
}

.form-group {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.form-group label {
  width: 160px;
  margin-right: 30px;
  text-align: right;
  margin-bottom: 0px;
}

.form-group input.form-control,
.form-group select.form-control {
  flex: 1;
  width: auto;
  margin-left: 0;
  margin-bottom: 0px;
  height: 40px;
}

#date_of_birth {
  flex: 0 0 200px;
  /* don't grow, don't shrink, fixed 100px */
  width: 200px;
}

p {
  padding: 20px;
  color: #be0808;
  border: 1px solid rgb(204, 202, 202);
  width: 80%;
  margin-left: 15%;
  border-radius: 5px;
  font-family: math;
}

.eye-icon {
  position: absolute;
  padding-right: 2px;
  right: 30px;
  cursor: pointer;
  color: grey;
}

.eye-icon:hover {
  color: rgb(77, 77, 77);
}

.roles-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px 16px;
}

.role-item {
  display: flex;
  align-items: center; 
  gap: 8px;
  user-select: none;
}
</style>